module.exports = __webpack_public_path__ + "img/marker-nodisc-red.97a067ba.png";